// Image asset manifest — beta. Update the file names in /app/frontend/public/uploads
// and these paths to swap content without code changes elsewhere.
//
// MISSING uploads (intentionally falls back to text-only cards / placeholders):
//   - Platform-collaboration photos

export const ASSETS = {
  founder: '/uploads/soo-li-theng.png',
  // Homepage hero image on the right side of the first screen.
  landingHero: '/uploads/landing-hero.jpg',
  // About-Us page top hero image (intentionally distinct from the offline-class photo).
  aboutHero: '/uploads/about-hero.jpg',
  consultants: {
    'soo-li-theng': '/uploads/soo-li-theng.png',
    jessie: '/uploads/jessie.jpg',
    rebecca: '/uploads/rebecca.png',
  },
  // Used in the homepage course preview hero.
  offlineClass: '/uploads/offline-class.jpg',
};

// Confinement centres (logo-style). Tile is text-only when image is null.
export const CENTRES = [
  { id: 'labebe', name_zh: 'LaBébé', name_en: 'LaBébé', image: '/uploads/labebe.jpg' },
  { id: 'serenity', name_zh: 'Serenity Elite', name_en: 'Serenity Elite', image: '/uploads/serenity-elite.jpg' },
  { id: 'amazing', name_zh: 'Amazing Postnatal Care', name_en: 'Amazing Postnatal Care', image: '/uploads/amazing.jpg' },
  { id: '28goodday', name_zh: '好日子产后护理 28 Good Days', name_en: '28 Good Days Care Center', image: '/uploads/28-goodday.png' },
  { id: 'virtuous', name_zh: 'Virtuous Confinement', name_en: 'Virtuous Confinement', image: '/uploads/virtuous-confinement.jpg' },
  { id: 'golden-moon', name_zh: '黄金岁月产后护理中心', name_en: 'Golden Moon Postnatal Centre', image: '/uploads/golden-moon.jpg' },
  { id: '55petals', name_zh: '55 Petals Confinement', name_en: '55 Petals Confinement', image: '/uploads/55-petals.webp' },
  { id: 'sy', name_zh: 'SY Postpartum Care Centre', name_en: 'SY Postpartum Care Centre', image: '/uploads/sy-postpartum.jpg' },
  { id: 'queensway', name_zh: 'Queensway Confinement', name_en: 'Queensway Confinement', image: '/uploads/queensway-confinement.jpg' },
];

// Media / platform gallery. Tiles fall back to icon placeholder when image is null.
// Tile 1 (offline-class) shows the offline mother-baby class group photo.
// Tile 4 (centre-class) shows a dedicated confinement-centre class photo so it
// doesn't visually duplicate tile 1.
export const MEDIA_GALLERY = [
  { id: 'offline-class', label_zh: '线下母婴课程', label_en: 'Offline Mother-Baby Class', image: '/uploads/offline-class.jpg' },
  { id: 'platform', label_zh: '平台合作', label_en: 'Platform Collaboration', image: '/uploads/platform-collaboration.jpg' },
  { id: 'radio', label_zh: '电台访问', label_en: 'Radio Interview', image: '/uploads/radio-interview.jpg' },
  { id: 'centre-class', label_zh: '月子中心课程', label_en: 'Confinement-Centre Class', image: '/uploads/centre-class.jpg' },
];
